import axiosGdt from '../utils/axiosGdt';

import {
  DataPostRecoverEmail,
  ResponseRecoverEmail,
  GDTApiErrors,
} from '@/types';
import { URLs, axiosErrorHandler } from '@/utils';
import { TEXTS } from '@/utils/constants';

export const postRecoverEmail = axiosErrorHandler(
  async (
    step: number,
    { selectedTypeDoc, docNumber }: DataPostRecoverEmail
  ) => {
    const params = `&paso=${step}&tipoDocumentoId=${encodeURIComponent(
      selectedTypeDoc.value
    )}&nroDocumento=${encodeURIComponent(docNumber)}`;
    const response = await axiosGdt.post<ResponseRecoverEmail | GDTApiErrors>(
      `${URLs.AUTH0_RECUPERAR_EMAIL}&${params}`
    );
    return response.data;
  },
  TEXTS.callCenterError
);
